import { useCallback, useState } from 'react';

import { useHydrated } from 'helpers/useHydrated';

import {
  commitRecentLocationSearch,
  readRecentLocationSearches,
  recentEntryIdentity,
  type RecentLocationSearchEntry,
  removeRecentLocationSearch,
  writeRecentLocationSearches,
} from './recentLocationSearches';

export const useRecentLocationSearches = () => {
  const isHydrated = useHydrated();
  const [recentSearches, setRecentSearches] = useState<RecentLocationSearchEntry[]>(
    readRecentLocationSearches,
  );

  const rememberRecentSearch = useCallback((entry: RecentLocationSearchEntry) => {
    setRecentSearches((prev) => {
      const next = commitRecentLocationSearch(prev, entry);
      writeRecentLocationSearches(next);
      return next;
    });
  }, []);

  const removeRecentSearch = useCallback((entry: RecentLocationSearchEntry) => {
    setRecentSearches((prev) => {
      const next = removeRecentLocationSearch(prev, recentEntryIdentity(entry));
      writeRecentLocationSearches(next);
      return next;
    });
  }, []);

  const clearRecentSearches = useCallback(() => {
    setRecentSearches([]);
    writeRecentLocationSearches([]);
  }, []);

  return {
    recentSearches: isHydrated ? recentSearches : [],
    rememberRecentSearch,
    removeRecentSearch,
    clearRecentSearches,
  };
};
